export default "__VITE_ASSET__CZkI$z6$__"